document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('page standard');

  if (run.length > 0) {
    // SHOW / HIDE SUMMARY
    
    window.atlas = window.atlas || {};
    window.atlas.standard = {};
    window.atlas.standard.videoComplete = false;

    // AUTOPLAY NEXT VIDEO
    let nextLesson = document.getElementById('next-lesson');

    // TOPICS PAGE - GET NEXT VIDEO
    if (nextLesson === null) {
      const lessons = document.querySelectorAll('.lesson');
      let counter = 0;

      Array.from(lessons).forEach((lesson) => {
        if (lesson.classList.contains('current-lesson') && nextLesson === null) {
          nextLesson = lessons[counter + 1];
        }
        counter += 1;
      });
    }

    const hideActions = () => {
      const actions = document.querySelectorAll('.action');

      actions.forEach((action) => {
        action.classList.add('hidden');
      });
    };

    const showAction = (action) => {
      const element = document.querySelector('.' + action);
      element.classList.remove('hidden');
    };

    const summaryButton = document.getElementById('summary');
    const transcriptButton = document.getElementById('transcript');
    const feedbackButton = document.getElementById('feedback');

    const feedbackToggle = (event) => {
      event.preventDefault();
      hideActions();

      if (feedbackButton.dataset.active == 'inactive') {
        showAction('feedback');
        feedbackButton.dataset.active = 'active';
        document.querySelector('.likert-question').classList.remove('hidden');
      } else {
        feedbackButton.dataset.active = 'inactive';
      }

      transcriptButton.dataset.active = 'inactive';
      summaryButton.dataset.active = 'inactive';
      window.atlas.likert.reset();

      if(window.atlas.standard.videoComplete) {
        const playerContainer = document.querySelector('#player-container');
        const actions = document.querySelector('.actions');
        const action = document.querySelector('.action.feedback');
        const actionTrigger = document.querySelector('#feedback');
        const likertQuestion = document.querySelector('.component.likert-question');

        playerContainer.style.display = 'block';
        actions.classList.remove('hidden');
        action.classList.add('hidden');
        actionTrigger.classList.add('hidden');
        likertQuestion.classList.add('hidden');

        if(window.MASSOLIT.autoplay && nextLesson) {
          window.location.href = nextLesson.value || nextLesson.dataset.url;
        }
      }
    };

    feedbackButton.addEventListener('click', (e) => {
      feedbackToggle(e);
    });

    document.addEventListener('close:likert', (e) => {
      feedbackToggle(e);
    });

    summaryButton.addEventListener('click', (e) => {
      e.preventDefault();
      hideActions();

      if (summaryButton.dataset.active == 'inactive') {
        showAction('summary');
        summaryButton.dataset.active = 'active';
      } else {
        summaryButton.dataset.active = 'inactive';
      }
      feedbackButton.dataset.active = 'inactive';
      transcriptButton.dataset.active = 'inactive';
    });

    // SHOW / HIDE TRANSCRIPT

    transcriptButton.addEventListener('click', (e) => {
      e.preventDefault();
      hideActions();

      if (transcriptButton.dataset.active == 'inactive') {
        showAction('transcript');
        transcriptButton.dataset.active = 'active';
      } else {
        transcriptButton.dataset.active = 'inactive';
      }
      feedbackButton.dataset.active = 'inactive';
      summaryButton.dataset.active = 'inactive';
    });

    // AUTOPLAY
    const autoplay = document.getElementById('autoplay');
    const csrfToken = document.querySelector("[name='csrf-token']").content;

    const setAutoPlay = () => {
      fetch('/users/current', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken, 
        },
        body: JSON.stringify({ user: { autoplay: window.MASSOLIT.autoplay } })
      });
    };

    window.MASSOLIT = window.MASSOLIT || {};
    window.MASSOLIT.autoplay = autoplay.dataset.active === 'active';

    autoplay.addEventListener('click', (e) => {
      e.preventDefault();

      if (window.MASSOLIT.autoplay) {
        autoplay.dataset.active = 'inactive';
        window.MASSOLIT.autoplay = false;
      } else {
        autoplay.dataset.active = 'active';
        window.MASSOLIT.autoplay = true;
      }

      setAutoPlay();
    });

    window._wq = window._wq || [];
    window._wq.push({
      id: 'wistia_embed',
      onHasData: (video) => {

        // AUTOPLAY NEXT VIDEO
        video.bind('end', () => {
          if(window.MASSOLIT.autoplay && nextLesson && window.atlas.likert.submitted) {
            window.location.href = nextLesson.value || nextLesson.dataset.url;
          }
        });

        // SHOW LIKERT SCALE BUTTON AT 80%
        video.bind('secondchange', (time) => {
          const percentage = (time / video.duration() * 100);
          if(percentage >= 80) {
            const feedbackButton = document.querySelector('#feedback');
            feedbackButton.classList.remove('invisible');
          }
        });

        // SHOW LIKERT AT END OF VIDEO
        video.bind('end', () => {
          if(window.atlas.likert.submitted === false) {
            const playerContainer = document.querySelector('#player-container');
            const actions = document.querySelector('.actions');
            const action = document.querySelector('.action.feedback');
            const likertQuestion = document.querySelector('.component.likert-question');

            playerContainer.style.display = 'none';
            actions.classList.add('hidden');
            action.classList.remove('hidden');
            likertQuestion.classList.remove('hidden');
            window.atlas.standard.videoComplete = true;
          }
        });

        // TRANSCRIPT
        video.bind('secondchange', (time) => {
          const subtitles = document.getElementsByClassName('subtitle');
          const offsets = [];
          const active = [];

          Array.from(subtitles).forEach((subtitle) => {
            subtitle.classList.remove('active');

            if(parseInt(subtitle.dataset.timestamp) <= Math.floor(time)) {
              active.push(subtitle); 
              offsets.push(subtitle.offsetHeight + 2); // 2 = css gap
            }
          });

          if (active.length > 0) {
            const activeSubTitle = active.slice(-1)[0];
            const container = document.getElementById('subtitles');

            activeSubTitle.classList.add('active');

            // Sum the offsetHeight of all the subtitles above the current
            // subtitle. Scroll down to the offset option
            container.scrollTop = offsets.reduce((a, b) => a + b, 0) - activeSubTitle.offsetHeight;
          }
        });

        const subtitles = document.getElementsByClassName('subtitle');
        Array.from(subtitles).forEach((subtitle) => {
          subtitle.addEventListener('click', (e) => {
            e.preventDefault();
            const timestamp = parseInt(subtitle.dataset.timestamp);
            video.time(timestamp);
            video.play();
          });
        });
      }
    }); 
  }
});
